import { Routes } from '@models/route';
import { lazy } from 'react';

const Settings = lazy(() => import('@pages/settings').then((p) => ({ default: p.Settings })));

const LocationDetail = lazy(() =>
  import('@pages/settings/components/locations/LocationDetail').then((p) => ({
    default: p.LocationDetail
  }))
);

export const SettingRoutes: Routes = [
  {
    path: 'settings',
    component: Settings,
    children: [
      {
        path: 'location/create',
        component: LocationDetail
      },
      {
        path: 'location/:locationId',
        component: LocationDetail
      }
    ]
  }
];
